<template>
  <div
    class="pointer-events-none fixed bottom-2 left-1/2 z-50 w-fit -translate-x-1/2 transform lg:left-auto lg:right-4 lg:translate-x-0"
  >
    <output
      role="status"
      class="relative mb-3 flex min-h-11 max-w-sm items-center gap-x-2 rounded-lg bg-gray-50 px-4 py-2 shadow-lg"
    >
      <TwSpinner class="h-5 w-5 text-gray-500" />
      <div class="pointer-events-none flex max-w-sm flex-col">
        <span class="truncate text-sm text-gray-600">
          {{ title }}
        </span>
        <p class="pointer-events-none break-words text-xs text-gray-400">
          {{ description }}
        </p>
      </div>
    </output>
  </div>
</template>

<script setup lang="ts">
defineProps<{ title: string; description?: string }>()
</script>
